import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getTokensStateOptions,
  PlayerTokenStateResponse,
  TokenType,
} from '@/apis/pam-player-tokens-api'

export type CoinsState = {
  goldCoinsAmount: number
  sweepsCoinsAmount: number
}

export const getCoinAmount = (data: PlayerTokenStateResponse | undefined) => {
  if (!data) {
    return undefined
  }
  return {
    goldCoinsAmount: getTokenAmount(data.tokens, 'GC') || 0,
    sweepsCoinsAmount: getSweepsAmount(
      getTokenAmount(data.tokens, 'USE'),
      getTokenAmount(data.tokens, 'RSE'),
    ),
    redeemableSweepsCoinsAmount: getTokenAmount(data.tokens, 'RSE') || 0,
  }
}

const getTokenAmount = (
  tokens: PlayerTokenStateResponse['tokens'],
  type: TokenType,
) => {
  return tokens?.find(({ tokenType }) => tokenType === type)?.amount
}

const getSweepsAmount = (fscAmount?: number, rscAmount?: number) => {
  return (fscAmount || 0) + (rscAmount || 0)
}

export const getCoinsStateQueryOptions = () => {
  return queryOptions({
    ...getTokensStateOptions(),
    refetchInterval: 5000,
    refetchOnWindowFocus: 'always',
    select: (data) => getCoinAmount(data),
  })
}

export const useCoinsStateQuery = () => {
  const queryClient = useQueryClient()
  const baseOptions = getCoinsStateQueryOptions()
  const queryDefaults = queryClient.getQueryDefaults(baseOptions.queryKey)

  const refetchInterval =
    queryDefaults?.refetchInterval ?? baseOptions.refetchInterval

  return useQuery({
    ...baseOptions,
    refetchInterval,
  })
}
